import { useContext } from 'react';

import { WebinarRoomContext } from './WebinarRoomContext';

const useWebinarRoomContext = () => {
  const context = useContext(WebinarRoomContext);
  if (!context) {
    throw new Error('useWebinarRoomContext must be used within a WebinarRoomContextProvider');
  }
  return context;
};

export default useWebinarRoomContext;
